export default "__VITE_ASSET__9b5eae40__"